"use client";

import { Transition } from "@headlessui/react";
import { Fragment, ReactNode } from "react";

interface FadeProps {
  show: boolean;
  children: ReactNode;
}

export function Fade({ show, children }: Readonly<FadeProps>) {
  return (
    <Transition
      show={show}
      as={Fragment}
      enter="transition-opacity duration-150"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-150"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      {children}
    </Transition>
  );
}

interface SlideProps {
  show: boolean;
  children: ReactNode;
}

export function Slide({ show, children }: Readonly<SlideProps>) {
  return (
    <Transition
      show={show}
      as={Fragment}
      enter="transform transition-all duration-200"
      enterFrom="opacity-0 translate-y-2"
      enterTo="opacity-100 translate-y-0"
      leave="transform transition-all duration-200"
      leaveFrom="opacity-100 translate-y-0"
      leaveTo="opacity-0 translate-y-2"
    >
      {children}
    </Transition>
  );
}

interface SpinnerProps {
  className?: string;
}

export function Spinner({ className = "h-5 w-5" }: Readonly<SpinnerProps>) {
  return (
    <svg
      className={`animate-spin text-current ${className}`}
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
    >
      <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
      <path
        className="opacity-75"
        fill="currentColor"
        d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
      />
    </svg>
  );
}
